import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Range } from "react-range";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import Products from "../components/products/Products";
import Categorys from "../components/Categorys";
import { AiFillStar } from "react-icons/ai";
import { CiStar } from "react-icons/ci";
import { BsFillGridFill } from "react-icons/bs";
import { FaThList } from "react-icons/fa";
import ShopProducts from "../components/products/ShopProducts";
import Pagination from "../components/Pagination";
import NoProductsMessage from "../components/NoProductsMessage";
import ProductsLoader from "../components/ProductsLoader";
import {
  price_range_product,
  query_products,
  get_banners,
  setLoading,
  setSearching,
  get_category,
} from "../store/reducers/homeReducer";
import { useDispatch, useSelector } from "react-redux";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Shops = ({ sellerId, sellerName }) => {
  const {
    products,
    totalProduct,
    latest_product,
    categorys,
    priceRange,
    parPage,
    banners,
    isLoading,
    isSearching,
  } = useSelector((state) => state.home);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [styles, setStyles] = useState("grid");
  const [filter, setFilter] = useState(true);
  const [category, setCategory] = useState("");
  const [state, setState] = useState({
    values: [priceRange.low, priceRange.high],
  });
  const [rating, setRatingQ] = useState("");
  const [sortPrice, setSortPrice] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");

  // Set document title
  useEffect(() => {
    document.title = "4POS eCommerce Customer";
  }, []);

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(price_range_product(sellerId));
    dispatch(get_banners(sellerId));
    dispatch(get_category(sellerId));
  }, [dispatch, sellerId]);
  useEffect(() => {
    setState({
      values: [
        priceRange.low,
        priceRange.high === priceRange.low
          ? priceRange.high + 1
          : priceRange.high,
      ],
    });
  }, [priceRange]);

  const queryCategoey = (e, value) => {
    if (e.target.checked) {
      setCategory(value);
    } else {
      setCategory("");
    }
  };
  // console.log(category);
  useEffect(() => {
    if (priceRange.low > 0) { // Only query if price range is loaded
      dispatch(setSearching(true));
      dispatch(
        query_products({
          query: {
            low: state.values[0],
            high: state.values[1],
            category,
            rating,
            sortPrice,
            pageNumber,
          },
          sellerId: sellerId,
        })
      );
    }
  }, [
    state.values[0],
    state.values[1],
    category,
    rating,
    pageNumber,
    sortPrice,
  ]);

  useEffect(() => {
    if (latest_product && latest_product.length > 0) {
      const symbol = latest_product[0][0].currency || "";
      setCurrencySymbol(symbol);
    }
  }, [latest_product]);

  const resetRating = () => {
    setRatingQ("");
    dispatch(setSearching(true));
    dispatch(
      query_products({
        query: {
          low: state.values[0],
          high: state.values[1],
          category,
          rating: "",
          sortPrice,
          pageNumber,
        },
        sellerId: sellerId,
      })
    );
  };




  return (
    <>
      <Headers sellerId={sellerId} sellerName={sellerName} />
      <section className="h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left">
        <Carousel
          autoPlay={true}
          infinite={true}
          arrows={false}
          showDots={false}
          responsive={responsive}
          className="h-full"
        >
          {banners &&
            banners?.length > 0 &&
            banners?.map((b, i) => (
              <div key={i} className="h-full w-full">
                <img
                  className="w-full h-full object-cover"
                  src={b.banner}
                  alt=""
                />
              </div>
            ))}
        </Carousel>
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              {/* <h2 className="text-xl font-bold">4POS</h2> */}
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <Link to={`/${sellerName}`}>Home</Link>
                <span className="pt-1">
                  <MdOutlineKeyboardArrowRight />
                </span>
                <span>Products</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Category Section */}
      <div className="my-4">
        <Categorys sellerId={sellerId} sellerName={sellerName} />
      </div>
      
      <section className="py-16">
        <div className="w-[85%] md:w-[90%%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className={`md:block hidden ${!filter ? "mb-6" : "mb-0"}`}>
            <button
              onClick={() => setFilter(!filter)}
              className="text-center w-full py-2 px-3 bg-indigo-500 text-white"
            >
              Filter Product
            </button>
          </div>
          <div className="w-full flex flex-wrap">
            <div
              className={`w-3/12 md-lg:w-4/12 md:w-full pr-8 ${
                filter
                  ? "md:h-0 md:overflow-hidden md:mb-6"
                  : "md:h-auto md:overflow-auto md:mb-0"
              }`}
            >
              <h2 className="text-xl font-bold mb-3 text-slate-600">
                Category
              </h2>
              <div className="py-2">
                {categorys.map((c, i) => (
                  <div
                    className="flex justify-start items-center gap-2 py-1"
                    key={i}
                  >
                    <input
                      checked={category === c.name ? true : false}
                      onChange={(e) => queryCategoey(e, c.name)}
                      type="checkbox"
                      id={c.name}
                    />
                    <label
                      className="text-slate-600 block cursor-pointer"
                      htmlFor={c.name}
                    >
                      {c.name}
                    </label>
                  </div>
                ))}
              </div>
              <div className="py-2 flex flex-col gap-5">
                <h2 className="text-xl font-bold mb-3 text-slate-600">Price</h2>
                <Range
                  step={1}
                  min={priceRange.low}
                  max={
                    priceRange.high === priceRange.low
                      ? priceRange.high + 1
                      : priceRange.high
                  }
                  values={state.values}
                  onChange={(values) => {
                    setState({ values });
                    dispatch(setSearching(true));
                  }}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      className="w-full h-[6px] bg-slate-200 rounded-full cursor-default"
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      className="w-[15px] h-[15px] bg-blue-500 rounded-full"
                      {...props}
                    />
                  )}
                />
                <div>
                  <span className="text-red-500 font-bold text-lg">
                    {currencySymbol}
                    {Math.floor(state.values[0])} - {currencySymbol}
                    {Math.floor(state.values[1])}
                  </span>
                </div>
              </div>
              {/* <div className="py-3 flex flex-col gap-4">
                <h2 className="text-xl font-bold mb-3 text-slate-600">
                  Rating
                </h2>
                <div className="flex flex-col gap-3">
                  <div
                    onClick={() => {
                      setRatingQ(5);
                      dispatch(setSearching(true));
                    }}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                  </div>
                  <div
                    onClick={() => {
                      setRatingQ(4);
                      dispatch(setSearching(true));
                    }}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                  <div
                    onClick={() => {
                      setRatingQ(3);
                      dispatch(setSearching(true));
                    }}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                  <div
                    onClick={() => {
                      setRatingQ(2);
                      dispatch(setSearching(true));
                    }}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                  <div
                    onClick={() => {
                      setRatingQ(1);
                      dispatch(setSearching(true));
                    }}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <AiFillStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                  <div
                    onClick={resetRating}
                    className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                  >
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                    <span>
                      <CiStar />
                    </span>
                  </div>
                </div>
              </div> */}
              {/* <div className="py-5 flex flex-col gap-4 md:hidden">
                <Products
                  title="Latest Products"
                  products={latest_product}
                  sellerId={sellerId}
                />
              </div> */}
            </div>
            <div className="w-9/12 md-lg:w-8/12 md:w-full">
              <div className="pl-8 md:pl-0">
                <div className="py-4 bg-white mb-10 px-3 rounded-md flex justify-between items-start border">
                  <h2 className="text-lg font-medium text-slate-600">
                    {totalProduct} Products
                  </h2>
                  {totalProduct > 0 && (
                    <div className="flex justify-center items-center gap-3">
                      <select
                        onChange={(e) => {
                          setSortPrice(e.target.value);
                          dispatch(setSearching(true));
                        }}
                        className="p-1 border outline-0 text-slate-600 font-semibold"
                        name=""
                        id=""
                      >
                        <option value="">Sort By</option>
                        <option value="low-to-high">Low to High Price</option>
                        <option value="high-to-low">High to Low Price</option>
                      </select>
                      <div className="flex justify-center items-start gap-4 md-lg:hidden">
                        <div
                          onClick={() => setStyles("grid")}
                          className={`p-2 ${
                            styles === "grid" && "bg-slate-300"
                          } text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}
                        >
                          <BsFillGridFill />
                        </div>
                        <div
                          onClick={() => setStyles("list")}
                          className={`p-2 ${
                            styles === "list" && "bg-slate-300"
                          } text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm`}
                        >
                          <FaThList />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="pb-8">
                  {isLoading ? (
                    <ProductsLoader isInitialLoad={true} />
                  ) : isSearching ? (
                    <ProductsLoader isInitialLoad={false} />
                  ) : !products || products.length === 0 ? (
                    <NoProductsMessage 
                      title="No Products Found"
                      message="We couldn't find any products matching your criteria."
                      suggestions={[
                        "Adjusting the price range",
                        "Removing the rating filter",
                        "Checking different categories",
                        "Clearing all filters"
                      ]}
                    />
                  ) : (
                    <ShopProducts
                      products={products}
                      styles={styles}
                      sellerId={sellerId}
                      sellerName={sellerName}
                    />
                  )}
                </div>
                {totalProduct > parPage && (
                  <div>
                    <Pagination
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                      totalItem={totalProduct}
                      parPage={parPage}
                      showItem={Math.floor(totalProduct / parPage)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer sellerId={sellerId} sellerName={sellerName} />
    </>
  );
};

export default Shops;